import { createFilterAtoms } from '@/common/filtering/store.ts';
import { resetLocationPaginationOnFilterChangeAtom } from '@/features/data/locations/pagination.ts';
import {
  DEFAULT_LOCATION_FILTER,
  type LocationFilterDefinition,
} from '@pac/filter/shared/locations';

export const locationFilterAtoms = createFilterAtoms<LocationFilterDefinition>(
  DEFAULT_LOCATION_FILTER,
  resetLocationPaginationOnFilterChangeAtom,
);
